import { inject } from '@angular/core';

import { TranslateService, TranslationObject } from '@ngx-translate/core';

import { DEFAULT_LANGUAGE } from '../../constants/language.constants';
import { LanguagePreferenceService } from '../../services/language/language-preference.service';

import { enTranslations } from '../../../feature-shell/assets/i18n';

export function initializeLanguage() {
  const translate = inject(TranslateService);
  const languagePreference = inject(LanguagePreferenceService);

  translate.setTranslation(DEFAULT_LANGUAGE, enTranslations as unknown as TranslationObject);

  return translate.use(languagePreference.getStoredPreference() ?? DEFAULT_LANGUAGE);
}
